// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Config from "../../../../Config.bs.js";
import * as CountryConfig from "../../country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as UrlUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/UrlUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as GeoRegionRepoConfig from "./GeoRegionRepoConfig.bs.js";

function fetchGeoRegions(country) {
  var requestUrl = UrlUtils$Catalyst.createRequestURLfrmParams(Config.Env.getHostName(undefined), "/geo_regions/all_geo_regions", {});
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(GeoRegionRepoConfig.GeoRegionResponseConverter.execute, result);
                        });
            });
}

function useGeoRegions(country) {
  var match = React.useState(function () {
        return {
                TAG: /* Loading */0,
                _0: undefined
              };
      });
  var updateGeoRegions = match[1];
  var $$fetch = function (param) {
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return fetchGeoRegions(country);
                }), (function (data) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(updateGeoRegions, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          $$fetch(undefined);
          
        }), []);
  return match[0];
}

var GeoRegionRepo = {
  fetchGeoRegions: fetchGeoRegions,
  useGeoRegions: useGeoRegions
};

export {
  GeoRegionRepo ,
  
}
/* react Not a pure module */
